module.exports = __webpack_public_path__ + "img/pijltje-blauw-rechts.eb3072a178eedaf27d7ece286cfd2a7d.svg";